import "~/misc/common";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    console.log('initAttachmentsForm');
    $(".attachment_attributes_uri").on('change', function () {
      const el = this as HTMLInputElement;
      if (el.files && el.files[0]) {
        $(el).parent().parent().parent().find('.selected-file').val(el.files[0].name);
        $(el).parent().parent().parent().find('.destroy_attachment_checkbox').attr('value', 'false');
        $(el).parent().parent().parent().find('.selected-file-view').show(300);
      }
    });
    $('.destroy-attachment').on('click', function (e) {
      console.log('Destroy clicked');
      $(this).parent().parent().find('.selected-file').val('');
      $(this).parent().parent().parent().find('.destroy_attachment_checkbox').attr('value', 'true');
      $(this).parent().parent().parent().parent().find('.selected-file-view').hide(300);
      e.preventDefault();
    });
  }
}